<template>
  <b-tabs v-if="debugActive === true" card>
    <b-tab title="Content" active>
      <b-card-text></b-card-text>
    </b-tab>
    <b-tab title="Api Response">
      <b-card-text>
        <pre>
      {{ apiResponse }}
    </pre
        >
      </b-card-text>
    </b-tab>
  </b-tabs>
</template>

<script>
export default {
  name: 'DebugBar',
  props: {
    apiResponse: {
      type: Object,
      default() {
        return {}
      },
    },
    valueName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      debugActive: false,
    }
  },
  mounted() {
    this.debugActive = this.$router.history.current.query.debug ? true : false
  },
}
</script>
